// Here, the criteria we need is screen width,
// and not necessarily if this is a mobile device.
export default function isSmallScreen(breakpoint = 768) {
  if (window) {
    const width = window.innerWidth;
    return width <= breakpoint;
  }
  return false;
}
